var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accessSchedules"},[_c('Table',{ref:"table",attrs:{"headerData":_vm.headerData,"data-table":'accessSchedules'},scopedSlots:_vm._u([{key:"content",fn:function(ref){
var contentProp = ref.contentProp;
return [_c('div',{staticClass:"name"},[_vm._v(" "+_vm._s(contentProp.name)+" ")])]}}])}),(_vm.showDialog)?_c('AddSchedules',{on:{"success":_vm.reload}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }